// Import model
import { DataviewFcb2BUnderlaymentOptionResponse } from '../models/DataviewFcb2BUnderlaymentOptionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { Fcb2BUnderlaymentOption } from '../models/Fcb2BUnderlaymentOption';
import { FilterFcb2BUnderlaymentOptionRequest } from '../models/FilterFcb2BUnderlaymentOptionRequest';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { Fcb2BUnderlaymentOptionSerializer } from './Fcb2BUnderlaymentOptionSerializer';
import { FilterFcb2BUnderlaymentOptionRequestSerializer } from './FilterFcb2BUnderlaymentOptionRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewFcb2BUnderlaymentOptionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewFcb2BUnderlaymentOptionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewFcb2BUnderlaymentOptionResponse instance
   */
  static deserialize(json: string): DataviewFcb2BUnderlaymentOptionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewFcb2BUnderlaymentOptionResponse instance
   */
  static fromObject(obj: any): DataviewFcb2BUnderlaymentOptionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewFcb2BUnderlaymentOptionResponse');
    }


    const instance: DataviewFcb2BUnderlaymentOptionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        Fcb2BUnderlaymentOptionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterFcb2BUnderlaymentOptionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewFcb2BUnderlaymentOptionResponse instances
   */
  static deserializeArray(json: string): DataviewFcb2BUnderlaymentOptionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewFcb2BUnderlaymentOptionResponse instance to a JSON string
   */
  static serialize(instance: DataviewFcb2BUnderlaymentOptionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewFcb2BUnderlaymentOptionResponse instance to a plain object
   */
  static toObject(instance: DataviewFcb2BUnderlaymentOptionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        Fcb2BUnderlaymentOptionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterFcb2BUnderlaymentOptionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewFcb2BUnderlaymentOptionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewFcb2BUnderlaymentOptionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
